import Room from '@models/building/Room';
import Systemselection from '@models/airvolumes/Systemselection'
import Valve from '@models/airvolumes/Valve'
import Configuration from "@models/project/Configuration";

/**
 *
 * @param id
 * @param isUnit
 * @param reset
 *
 * Berechnet die Anzahl von Ventile und Rohre je Raum.
 * Benötigt id einer Wohneinheit oder id eines Raums + isUnit = false.
 * Wird die unitId mitgegeben werden alle Räume der Wohneinheit berechnet.
 * Wird die roomId mitgegeben und isUnit = false werden die Ventile für den einzelnen Raum berechnet.
 * Reset = true setzt die Ventile der Räume/Raum zurück
 *
 */
export function calculateValves(id, isUnit = true, reset = false) {
  if (isUnit === true) {
    var rooms = Room.query().where('unitId', id).with(['airvolume']).get();
  } else {
    var rooms = Room.query().where('id', id).with(['airvolume']).get();
  }
  if (rooms.length == 0) return;

  var systemselection = Systemselection.query().where('unitId', rooms[0].unitId).first();

  rooms.forEach(room => {
    // Luftart Überströmöffnung oder LTM 7 enthalten keine Valves
    if (room.airType == 3 || room.ventilationMeasure == 7) return;

    // Ventil- und Rohrmenge ist abhängig von Flexpipe (rund/oval)
    if (systemselection.pipeProfile == 2) {
      var valveAmmount = Math.ceil(room.airvolume.airvolume / 40);
      var pipeAmmount = Math.ceil(room.airvolume.airvolume / valveAmmount / 20);
      var pipesystem = 2;
    } else {
      var valveAmmount = Math.ceil(room.airvolume.airvolume / 60);
      var pipeAmmount = Math.ceil(room.airvolume.airvolume / valveAmmount / 30);
    }

    const valves = Valve.query().where('roomId', room.id).get();
    if (valves.length == 0 || valves.length < valveAmmount || reset === 'valves') {
      var pipesystem = 1;
      if (systemselection.pipeSystem == 2) {
        pipesystem = 2;
      }
      // Alte Ventile löschen und neue hinzufügen
      Valve.delete((valve) => {
        return valve.roomId == room.id;
      })
      var changeablePipes = false;
      if (pipeAmmount == 1) changeablePipes = true;
      for (valveAmmount; valveAmmount > 0; valveAmmount--) {
        Valve.insert({
          data: {
            roomId: room.id,
            pipesAmmount: pipeAmmount,
            pipesystem: pipesystem,
            changeablePipes: changeablePipes
          }
        })
      }
    } else if (reset === 'pipes') {
      let storedValves = Valve.query().where('roomId', room.id).get()
      if (systemselection.pipeProfile == 2) {
        pipeAmmount = Math.ceil(room.airvolume.airvolume / storedValves.length / 20);
      } else {
        pipeAmmount = Math.ceil(room.airvolume.airvolume / storedValves.length / 30);
      }
      var changeablePipes = false;
      if (pipeAmmount == 1) changeablePipes = true;
      valves.forEach(valve => {
        Valve.update({
          where: valve.id,
          data: {
            changeablePipes: changeablePipes,
            pipesAmmount: pipeAmmount,
          }
        })
      })
    } else {
      valves.forEach(valve => {
        if (pipeAmmount == 1) {
          Valve.update({
            where: valve.id,
            data: {changeablePipes: true}
          })
        } else {
          Valve.update({
            where: valve.id,
            data: {changeablePipes: false}
          })
        }
      })
    }
  });
}
